"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Linda K.",
  quote: "\"I lost my smile as a young child in a bike wreck. After repeated redos by some dentists, Dr. Leclercq exceeded my expectations and got it right.\"",
  position: "DENTAL HYGIENIST",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/patient_jane_avatar.png"
}, {
  author: "Robert M.",
  quote: "Dr. Morr is a specialist in the reconstruction of teeth. He is known for his artistic abilities and perfectionism. It was totally worth the travel.",
  position: "FULL REHAB PATIENT",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/patient_mike_avatar.png"
}, {
  author: "Elena S.",
  quote: "The smile is the connection of your soul to the world. Dr. Morr's artistic vision and techniques gave me a result that was truly life-changing.",
  position: "SMILE DESIGN PATIENT",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/patient_sarah_avatar.png"
}];
export default function RealPatientExperiences() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23593" id="success-stories" ref={ref} className={cn("bg-white text-black py-24 relative overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-[#C19B4A]/5 rounded-full blur-3xl" />
        <div className="absolute top-[40%] -right-[10%] w-[40%] h-[60%] bg-[#6EC1E4]/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-black font-sans tracking-[0.2em] uppercase text-xs md:text-sm mb-4">
            OUR CLIENTS
          </h2>
          <h3 className="text-3xl md:text-[36px] font-serif text-[#C19B4A]">
            Success Stories
          </h3>
        </div>

        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} className="md:basis-4/5 lg:basis-3/4 pl-4">
                  <div data-index={i} className="flex flex-col items-center text-center p-6 md:p-12 select-none">
                    <Quote className="size-12 text-[#C19B4A]/20 mb-8 rotate-180" />
                    
                    <blockquote className="font-sans text-lg md:text-xl lg:text-2xl leading-relaxed text-black mb-10 max-w-3xl">
                      "{testimonial.quote}"
                    </blockquote>

                    <div className="flex flex-col items-center gap-4">
                      <SafeHydrate><Avatar className="size-16 border-2 border-[#C19B4A]/20">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="bg-[#C19B4A]/10 text-[#C19B4A] text-lg">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      
                      <div className="space-y-1">
                        <div className="font-medium text-lg text-black">
                          {testimonial.author}
                        </div>
                        <div className="text-xs text-gray-500 uppercase tracking-[0.2em]">
                          {testimonial.position}
                        </div>
                      </div>
                      
                      <div className="flex gap-1 text-[#C19B4A] mt-2">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-4 fill-current" data-index={starIndex} />)}
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="left-0 lg:-left-12 bg-white hover:bg-gray-50 border-[#DDDDDD] text-black border shadow-sm rounded-[4px]" />
              <CarouselNext className="right-0 lg:-right-12 bg-white hover:bg-gray-50 border-[#DDDDDD] text-black border shadow-sm rounded-[4px]" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}